import {
  ProjectionKind,
  TrainingSessionsByEmployeeDataTableQuery,
  useTrainingSessionsByEmployeeDataTable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import TrainingMembershipAttendanceDropdown from 'modules/trainings/components/Revamp/TrainingMembershipAttendanceDropdown'

import { attendanceFilter } from './AttendanceFilter'
import { BulkUpdateAttendanceAction } from './BulkUpdateAttendanceAction'
import { EventInfo } from './EventInfo'

type TrainingsSessionAccessMembership = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']
    >['edges'][0]
  >['node']
>

type Props = {
  trainingClassId: number
  accessId: number
  trainingClassName: string
}

const DEFAULT_NO_VALUE = '-'
export const SessionsDataTable = ({ trainingClassId, accessId, trainingClassName }: Props) => {
  const source = useTrainingSessionsByEmployeeDataTable(
    [
      {
        identifier: 'name',
        kind: ProjectionKind.Custom,
        template: '{{firstName}} {{lastName}}',
        title: i18n.t('trainings.trainings_revamp.employee_sidepanel.datatable.info'),
        render: ({ startsAt, endsAt, link, location }) => {
          return <EventInfo startsAt={startsAt} endsAt={endsAt} link={link} location={location} />
        },
        colSpan: 2,
      },

      {
        identifier: 'sessionAttendanceStatus',
        kind: ProjectionKind.Custom,
        render: ({ sessionAttendances }) => {
          const sessionAttendance = sessionAttendances.find(
            (sessionAtt) => sessionAtt.accessId === accessId
          )
          if (sessionAttendance) {
            return (
              <TrainingMembershipAttendanceDropdown
                idsAttendance={[sessionAttendance.id]}
                status={sessionAttendance?.status}
              />
            )
          } else {
            return DEFAULT_NO_VALUE
          }
        },
        template: '',
        title: i18n.t('trainings.trainings_revamp.employee_sidepanel.datatable.status'),
      },
    ],
    {
      variables: {
        accessId: accessId,
        trainingClassIds: [String(trainingClassId)],
      },
    }
  )

  return (
    <DataTable
      title={trainingClassName}
      disableExport
      pagination={{ kind: 'offset', itemsPerPage: 5 }}
      filters={[attendanceFilter(source)]}
      source={source}
      selectable={(item: TrainingsSessionAccessMembership) =>
        !item.sessionAttendances.some((attendance) => attendance.employeeId)
      }
      actions={<BulkUpdateAttendanceAction accessId={accessId} />}
    />
  )
}
